var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { translate } from '@utils/i18n';
import { showSuccessToast, showErrorToast } from '@ui';
import useUpdateDeficiencyDetail from '../../hooks/useUpdateDeficiency';
import useSyncDeficiencyWithAnswer from '../../hooks/useSyncDeficiencyWithAnswer';
function useDeficiencyActions(deficiencyId, namespace) {
    const { updateDeficiency } = useUpdateDeficiencyDetail();
    const { syncWithAnswer } = useSyncDeficiencyWithAnswer(deficiencyId);
    const handleReopen = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        try {
            yield updateDeficiency.mutateAsync({ id: deficiencyId, deficiencyUpdate: { isResolved: false } });
        }
        catch (_a) {
            showErrorToast(translate('error_message_updating', { namespace }));
        }
    }), [deficiencyId, namespace, updateDeficiency]);
    const handleSyncWithAnswer = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        try {
            yield syncWithAnswer.mutateAsync();
            showSuccessToast(translate('sync_with_answer_success', { namespace }));
        }
        catch (_a) {
            showErrorToast(translate('error_message_updating', { namespace }));
        }
    }), [namespace, syncWithAnswer]);
    const handleDeficiencyStatusChange = useCallback((value) => __awaiter(this, void 0, void 0, function* () {
        try {
            yield updateDeficiency.mutateAsync({ id: deficiencyId, deficiencyUpdate: { deficiencyStatus: value } });
            showSuccessToast(translate('deficiency_status_updated', { namespace }));
        }
        catch (_a) {
            showErrorToast(translate('error_message_updating', { namespace }));
        }
    }), [deficiencyId, namespace, updateDeficiency]);
    const handleResolutionStatusChange = useCallback((value) => __awaiter(this, void 0, void 0, function* () {
        try {
            yield updateDeficiency.mutateAsync({
                id: deficiencyId,
                deficiencyUpdate: { deficiencyResolutionStatus: Number(value) }
            });
            showSuccessToast(translate('resolution_status_updated', { namespace }));
        }
        catch (_a) {
            showErrorToast(translate('error_message_updating', { namespace }));
        }
    }), [deficiencyId, namespace, updateDeficiency]);
    const handleTagsChange = useCallback((values) => __awaiter(this, void 0, void 0, function* () {
        try {
            yield updateDeficiency.mutateAsync({ id: deficiencyId, deficiencyUpdate: { tagList: values } });
        }
        catch (_a) {
            showErrorToast(translate('error_message_updating', { namespace }));
        }
    }), [deficiencyId, namespace, updateDeficiency]);
    return {
        updateDeficiency,
        syncWithAnswer,
        handleReopen,
        handleSyncWithAnswer,
        handleDeficiencyStatusChange,
        handleResolutionStatusChange,
        handleTagsChange
    };
}
export default useDeficiencyActions;
